
// By default all video sources are not set to prevent videos being downloaded 
// on mobile, so we use JS to check the browser width, if it is tablet or wider,
// we update the video src.

$(document).ready(function() {
    var resizeTimer,
        hasUpdatedVideoSources = false;
    
    // On window resize, check if we need to update video visibility
    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            checkVideoVisibility();
        }, 200);
    });

    // Check if we need to update video visibility on page load
    checkVideoVisibility();


    
    // Functions
    // ---------

    function checkVideoVisibility() {
        // Check if the window is tablet size or wider
        if(!hasUpdatedVideoSources && window.matchMedia("(min-width: 768px)").matches) {
            updateVideoSources();
        }
    }

    function updateVideoSources() {
        // Update src attribute of each video <source> using value from data-src
        $('video source').each(function() {
            $(this).attr('src', $(this).attr('data-src'));
        });

        // After the video sources have been updated, load each video
        $('video').each(function() {
            $(this)[0].load();
        });

        hasUpdatedVideoSources = true;
    }
});